import React from 'react'
import styles from './Campaign.css'
import DataTable from "../DataTable/DataTable"
import LinkDuo from "../LinkDuo/LinkDuo"

const CampaignHeadersView = props => {
  const {inView, fullscreenImage} = props

  const {
    category,
    header_bold,
    header_light,
    header_sub,
    // manchet,
    data_list,
    cta_primary,
    cta_secondary,
  } = props.data

  return (
    <React.Fragment>
      {category &&
      <div
        className={inView ? styles.categoryInView : styles.category}
        style={{marginTop: fullscreenImage ? '0' : ''}}
      >
        {category}
        </div>
      }
      <div className={inView ? styles.headersInView : styles.headers}>
        <LinkDuo
          to={cta_primary.url}
          className={styles.headersLink}
          headerBold={header_bold}
          headerLight={header_light}
        >
          {header_bold &&
          <h1 dangerouslySetInnerHTML={{__html: header_bold}}/>
          }
          {header_light &&
          <h1 className="secondary" dangerouslySetInnerHTML={{__html: header_light}}/>
          }
        </LinkDuo>
        {header_sub &&
        <p className={styles.subHeader} dangerouslySetInnerHTML={{__html: header_sub}}/>
        }
        {/* {manchet &&
        <div className={styles.manchet} dangerouslySetInnerHTML={{__html: manchet}}/>
        } */}
        {data_list && data_list.length > 0 &&
        <DataTable items={data_list}/>
        }
      </div>
      <div className={inView ? styles.ctasInView : styles.ctas}>
        {cta_primary && cta_primary.url &&
        <LinkDuo
          to={cta_primary.url}
          className="button primary"
          headerBold={header_bold}
          aria-label={[cta_primary.label, header_bold].join(' ')}
        >
          {cta_primary.label}
        </LinkDuo>
        }
        {cta_secondary && cta_secondary.url &&
        <LinkDuo
          to={cta_secondary.url}
          className="button secondary"
          headerBold={cta_secondary.label}
          aria-label={[cta_primary.label, header_bold].join(' ')}
        >
          {cta_secondary.label}
        </LinkDuo>
        }
      </div>
    </React.Fragment>
  )
}

export default CampaignHeadersView;



// WEBPACK FOOTER //
// ./src/components/Campaign/CampaignHeadersView.js